<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  isFirst: {
    type: Boolean,
    required: true,
    default: false,
  },
})

const { $viewport } = useNuxtApp()
const { formatMarkdown } = useFormatters()

const expanded = ref(true)

const isMobile = computed(() => $viewport.isLessThan('desktop'))

onMounted(() => {
  if (isMobile.value && !props.isFirst) {
    expanded.value = false
  }
})
</script>
<template>
  <div>
    <div v-if="content.title" class="my-6 text-lg font-semibold text-gray-900">
      {{ content.title }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="md-content text-base font-normal text-gray-800"
      v-html="formatMarkdown(expanded ? content.text : '')"
    ></div>
    <!-- eslint-enable vue/no-v-html -->
    <span
      v-if="!expanded"
      class="mt-4 flex cursor-pointer items-center whitespace-nowrap font-sans text-gray-900 underline"
      @click="expanded = true"
      >Lees meer</span
    >
  </div>
</template>
